import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Quasar from 'quasar/src/vue-plugin.js';
import langEs from 'quasar/lang/es.js'
import langEn from 'quasar/lang/en-us.js'

Vue.use(VueI18n)

const messages = {}
const localeFiles = require.context('./locales', false, /\.js$/)
localeFiles.keys().forEach(fileName => {
  const localeCode = fileName.replace(/^\.\//, '').replace(/\.js$/, '')
  const localeModule = localeFiles(fileName).default || localeFiles(fileName)
  messages[localeCode] = localeModule
})

const localeList = Object.keys(messages).map(code => ({
  value: code,
  label: messages[code]?.meta?.label || code
}))

const savedLocale = typeof window !== 'undefined' ? window.localStorage.getItem('app-locale') : null
const defaultLocale = savedLocale || 'es'

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'es',
  messages
})

let currentLang = langEs
if (typeof window !== 'undefined') {
  const locale = window.localStorage.getItem('app-locale')
  if (locale === 'en') {
    currentLang = langEn
  }
}

function setLanguage(locale) {
  if (!messages[locale]) {
    return
  }

  i18n.locale = locale

  if (typeof window !== 'undefined') {
    window.localStorage.setItem('app-locale', locale)
  }
}

setLanguage(defaultLocale)

export { i18n, setLanguage, localeList, currentLang }
